import React, { useEffect } from 'react';
import ProfileSidebar from './components/ProfileSidebar';
import { useScreenDetector } from '../../hooks/useScreenDetector';
import BonusCard from './components/BonusCard';
import UserInfo from './components/UserInfo';
import { Order } from '../../types/Order.interface';
import { getStatusDescription } from '../../utils/getOrderStatusDescription';
import { getDeliveryTypeDescription } from '../../utils/getOrderDeliveryType';
import Preloader from '../../ui/Loader/Preloader';

interface Props {
  orders: Order[];
  getOrders: (page: number, limit: number) => void;
  formatDate: (date: string) => string;
  getPaymentStatus: (order: Order) => string;
  isLoading: boolean;
}

export const ProfileMain: React.FC<Props> = ({ orders, getOrders, formatDate, getPaymentStatus, isLoading }) => {
  const { isMobile } = useScreenDetector();

  useEffect(() => {
    getOrders(0, 1);
  }, []);


  if (isLoading) return <Preloader />;

  return (
    <div className="container mx-auto flex-1 py-8 px-4 md:px-6">
      <h1 className="mb-6 text-2xl font-bold">Личный кабинет</h1>

      <div className="flex flex-col space-y-6 md:flex-row md:space-x-6 md:space-y-0">
        <div className="w-full md:w-1/4">
          <ProfileSidebar />
        </div>

        <div className="w-full md:w-3/4 space-y-6">
          <UserInfo />
          <div className={`grid grid-cols-1 gap-6 ${!isMobile ? 'lg:grid-cols-2' : ''}`}>
            <BonusCard />
            <div>
              <h3 className="mb-4 text-xl font-bold">Последний заказ</h3>
              <div className="rounded-lg bg-white p-4 shadow">
                {
                  orders.length > 0 ? (
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-500">Номер заказа</p>
                        <p className="font-medium"><a href={`/m/${orders[0].orderHash}`}>{orders[0].orderNumber}</a></p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Дата</p>
                        <p className="font-medium">{formatDate(orders[0].createdAt)}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Статус</p>
                        <p className="font-medium text-green-600">{getStatusDescription(orders[0])}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Сумма</p>
                        <p className="font-medium">{orders[0].priceAmount} ₽</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Статус оплаты</p>
                        <p className="font-medium text-green-600">{getPaymentStatus(orders[0])}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Способ доставки</p>
                        <p className="font-medium">{getDeliveryTypeDescription(orders[0].delivery.type)}</p>
                      </div>
                      <div className="mt-4">
                        <a href="/profile/orders" className="text-sm text-autoparts-orange hover:underline">
                          Посмотреть все заказы →
                        </a>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <p className="text-sm text-gray-500">Заказов нет</p>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

